import React from 'react';
import { ShieldCheckIcon, LockIcon, MailIcon, CreditCardIcon, CheckCircleIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-forest/5 py-12 md:py-16 px-5" data-id="element-200">
      <div className="max-w-2xl mx-auto text-center" data-id="element-201">
        {/* Shield Badge */}
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-forest/10 mb-6" data-id="element-202">
          <ShieldCheckIcon className="w-10 h-10 text-forest" strokeWidth={1.5} data-id="element-203" />
        </div>

        {/* Headline */}
        <h2 className="font-serif text-forest text-2xl md:text-3xl font-bold mb-6 leading-tight" data-id="element-204">
          The "Thriving Garden" 7-Day Guarantee
        </h2>

        {/* Body */}
        <p className="font-sans text-gray-600 leading-relaxed mb-10 text-base md:text-lg max-w-xl mx-auto" data-id="element-205">
          If you read The 365 Garden Shield and don't feel 100% confident
          protecting your garden in any season, just email us within 7 days and
          we'll refund every penny. No questions. No hassle. Your garden's
          success is our only goal.
        </p>

        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-gray-500 font-sans" data-id="element-206">
          <div className="flex items-center gap-1.5" data-id="element-207">
            <LockIcon className="w-4 h-4 text-forest" data-id="element-208" />
            <span data-id="element-209">Secure Checkout</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-210">
            <MailIcon className="w-4 h-4 text-forest" data-id="element-211" />
            <span data-id="element-212">Instant Delivery</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-213">
            <CreditCardIcon className="w-4 h-4 text-forest" data-id="element-214" />
            <span data-id="element-215">Safe Payment</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-216">
            <CheckCircleIcon className="w-4 h-4 text-forest" data-id="element-217" />
            <span data-id="element-218">7-Day Guarantee</span>
          </div>
        </div>
      </div>

      {/* Section Divider */}
      <div className="section-divider mt-16" data-id="element-219" />
    </section>;
}